import { apiRequest } from '../config/apiRequest';
import API_ENDPOINTS from '../config/apiEndPoints';

export const createTrainingPlan = async (data, setError) => {
    try {
        const response = await apiRequest(API_ENDPOINTS.CREATE_TRAINING_PLANS, 'POST', data);
        if (response.statusCode === 200) {
            return response;
        } else {
            throw new Error(`Failed to create training plans. Status: ${response.statusCode}`);
        }
    } catch (err) {
        console.error(err);
        if (setError) {
            setError(err.message);
        }
        return null;
    }
};

export const updateTrainingPlan = async (data, setError) => {
    try {

        const endpoint = API_ENDPOINTS.UPDATE_TRAINING_PLANS.replace(':id', data.id);

        const response = await apiRequest(endpoint, 'PUT', data);
        if (response.statusCode === 200) {
            return response;
        } else {
            throw new Error(`Failed to update training plans. Status: ${response.statusCode}`);
        }
    } catch (err) {
        console.error(err);
        if (setError) {
            setError(err.message);
        }
        return null;
    }
};

export const deleteTrainingPlan = async (data, setError) => {
    try {
        const endpoint = API_ENDPOINTS.UPDATE_TRAINING_PLANS.replace(':id', data.id);

        const response = await apiRequest(endpoint, 'DELETE', data);
        if (response.statusCode === 200) {
            return response;
        } else {
            throw new Error(`Failed to update training plans. Status: ${response.statusCode}`);
        }
    } catch (err) {
        console.error(err);
        if (setError) {
            setError(err.message);
        }
        return null;
    }
};

export const createTrainingSession = async (data, setError) => {
    try {
        const response = await apiRequest(API_ENDPOINTS.CREATE_TRAINING_SESSIONS, 'POST', data);
        if (response.statusCode === 200) {
            return response;
        } else {
            throw new Error(`Failed to create training sessions. Status: ${response.statusCode}`);
        }
    } catch (err) {
        console.error(err);
        if (setError) {
            setError(err.message);
        }
        return null;
    }
};

export const updateTrainingSession = async (data, setError) => {
    try {
        const endpoint = API_ENDPOINTS.UPDATE_TRAINING_SESSIONS.replace(':id', data.id);
        const response = await apiRequest(endpoint, 'PUT', data);
        if (response.statusCode === 200) {
            return response;
        } else {
            throw new Error(`Failed to update training sessions. Status: ${response.statusCode}`);
        }
    } catch (err) {
        console.error(err);
        if (setError) {
            setError(err.message);
        }
        return null;
    }
};

export const deleteTrainingSession = async (data, setError) => {
    try {
        const endpoint = API_ENDPOINTS.DELETE_TRAINING_SESSIONS.replace(':id', data.id);
        const response = await apiRequest(endpoint, 'DELETE', data);
        if (response.statusCode === 200) {
            return response;
        } else {
            throw new Error(`Failed to update training sessions. Status: ${response.statusCode}`);
        }
    } catch (err) {
        console.error(err);
        if (setError) {
            setError(err.message);
        }
        return null;
    }
};

export const createSoilReport = async (data, setError) => {

    try {
        const response = await apiRequest(API_ENDPOINTS.CREATE_SOIL_REPORT, 'POST', data);
        if (response.statusCode === 200) {
            return response;
        } else {
            throw new Error(`Failed to create soil report. Status: ${response.statusCode}`);
        }
    } catch (err) {
        console.error(err);
        if (setError) {
            setError(err.message);
        }
        return null;
    }
};

export const updateSoilReport = async (data, setError) => {
    try {
        const endpoint = API_ENDPOINTS.UPDATE_SOIL_REPORT.replace(':reportId', data.id);
        const response = await apiRequest(endpoint, 'PUT', data);
        if (response.statusCode === 200) {
            return response;
        } else {
            throw new Error(`Failed to create soil report. Status: ${response.statusCode}`);
        }
    } catch (err) {
        console.error(err);
        if (setError) {
            setError(err.message);
        }
        return null;
    }
};
export const updateSoilVillageReport = async (data, setError) => {
    try {
        const response = await apiRequest(API_ENDPOINTS.UPDATE_VILLAGE_SOIL_REPORT, 'PUT', data);
        if (response.statusCode === 200) {
            return response;
        } else {
            throw new Error(`Failed to create soil report. Status: ${response.statusCode}`);
        }
    } catch (err) {
        console.error(err);
        if (setError) {
            setError(err.message);
        }
        return null;
    }
};

export const deleteSoilReport = async (data, setError) => {
    
    try {
        const endpoint = API_ENDPOINTS.UPDATE_SOIL_REPORT.replace(':id', data.id);
        
        const response = await apiRequest(endpoint, 'DELETE', data);
        if (response.statusCode === 200) {
            return response;
        } else {
            throw new Error(`Failed to create soil report. Status: ${response.statusCode}`);
        }
    } catch (err) {
        console.error(err);
        if (setError) {
            setError(err.message);
        }
        return null;
    }
};

export const createEmployee = async (data, setError) => {
    try {
        const response = await apiRequest(API_ENDPOINTS.CREATE_EMPLOYEE, 'POST', data);
        if (response.statusCode === 200) {
            return response;
        } else {
            throw new Error(`Failed to create employee. Status: ${response.statusCode}`);
        }
    } catch (err) {
        console.error(err);
        if (setError) {
            setError(err.message);
        }
        return null;
    }
};

export const fileUpload = async (data, setError) => {
    try {
        const response = await apiRequest(API_ENDPOINTS.FILEUPLOAD, 'POST', data);
        if (response.statusCode === 200) {
            return response;
        } else {
            throw new Error(`Failed to create fieldBook. Status: ${response.statusCode}`);
        }
    } catch (err) {
        console.error(err);
        if (setError) {
            setError(err.message);
        }
        return null;
    }
}


export const createFieldBook = async (data, setError) => {
    try {
        const response = await apiRequest(API_ENDPOINTS.CREATE_FIELD_BOOK, 'POST', data);
        if (response.statusCode === 200) {
            return response;
        } else {
            throw new Error(`Failed to create fieldBook. Status: ${response.statusCode}`);
        }
    } catch (err) {
        console.error(err);
        if (setError) {
            setError(err.message);
        }
        return null;
    }
}

export const deleteFieldBook = async (data, setError) => {
    try {
        const endpoint = API_ENDPOINTS.DELETE_FIELD_BOOK.replace(':id', data.id);
        const response = await apiRequest(endpoint, 'DELETE', data);
        if (response.statusCode === 200) {
            return response;
        } else {
            throw new Error(`Failed to update training plans. Status: ${response.statusCode}`);
        }
    } catch (err) {
        console.error(err);
        if (setError) {
            setError(err.message);
        }
        return null;
    }
}

export const updateFieldBook = async (data, setError) => {
    try {
        const endpoint = API_ENDPOINTS.UPDATE_FIELD_BOOK.replace(':id', data.id);
        const response = await apiRequest(endpoint, 'PUT', data);
        if (response.statusCode === 200) {
            return response;
        } else {
            throw new Error(`Failed to create soil report. Status: ${response.statusCode}`);
        }
    } catch (err) {
        console.error(err);
        if (setError) {
            setError(err.message);
        }
        return null;
    }
}



export const addAttendance = async (data, setError) => {
    try {
        const response = await apiRequest(API_ENDPOINTS.ADD_ATTENDANCE, 'POST', data);
        if (response.statusCode === 200) {
            return response;
        } else {
            throw new Error(`Failed to create training plans. Status: ${response.statusCode}`);
        }
    } catch (err) {
        console.error(err);
        if (setError) {
            setError(err.message);
        }
        return null;
    }
};



export const createAdOption = async (data, setError) => {
    try {
        const response = await apiRequest(API_ENDPOINTS.CREATE_ADOPTION, 'POST', data);
        if (response.statusCode === 200) {
            return response;
        } else {
            throw new Error(`Failed to create training plans. Status: ${response.statusCode}`);
        }
    } catch (err) {
        console.error(err);
        if (setError) {
            setError(err.message);
        }
        return null;
    }
};



export const deleteAdOption = async (data, setError) => {

    try {
        const endpoint = API_ENDPOINTS.DELETE_ADOPTION.replace(data);
        const response = await apiRequest(endpoint, 'DELETE', data);
        if (response.statusCode === 200) {
            return response;
        } else {
            throw new Error(`Failed to update training plans. Status: ${response.statusCode}`);
        }
    } catch (err) {
        console.error(err);
        if (setError) {
            setError(err.message);
        }
        return null;
    }
}



export const updateUpdateAdOption = async (data, setError) => {
    try {
        const response = await apiRequest(API_ENDPOINTS.UPDATE_ADOPTION, 'PUT', data);
        if (response.statusCode === 200) {
            return response;
        } else {
            throw new Error(`Failed to create soil report. Status: ${response.statusCode}`);
        }
    } catch (err) {
        console.error(err);
        if (setError) {
            setError(err.message);
        }
        return null;
    }
};